import React, { createContext, useContext, useState, useEffect } from "react";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import userPool from "./cognitoConfig";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Check for existing session on mount
    useEffect(() => {
        const cognitoUser = userPool.getCurrentUser();
        if (cognitoUser) {
            cognitoUser.getSession((err, session) => {
                if (!err && session.isValid()) {
                    setUser(cognitoUser);
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, []);

    const login = (username, password) => {
        return new Promise((resolve, reject) => {
            const cognitoUser = new CognitoUser({
                Username: username,
                Pool: userPool,
            });
            const authDetails = new AuthenticationDetails({
                Username: username,
                Password: password,
            });
            cognitoUser.authenticateUser(authDetails, {
                onSuccess: () => {
                    setUser(cognitoUser);
                    resolve();
                },
                onFailure: (err) => {
                    reject(err);
                },
            });
        });
    };

    const logout = () => {
        const cognitoUser = userPool.getCurrentUser();
        if (cognitoUser) {
            cognitoUser.signOut();
        }
        setUser(null);
    };

    const isAuthenticated = () => !!user;

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
